module.exports = __webpack_public_path__ + "img/paypal.56013ccd.png";